import { useDispatch, useSelector } from "react-redux";
import type { RootState } from "../store/index";
import { combineErrors, combineStatuses } from "../utils";
import {
  getReleaseNotesRequest,
  type ReleaseNotesRequestKey,
} from "../store/releaseNotesDuck";

export function useReleaseNotes() {
  const dispatch = useDispatch();

  const { releaseNotes } = useSelector(
    (state: RootState) => state.releaseNotes,
  );

  const loadReleaseNotes = () => {
    dispatch(getReleaseNotesRequest());
  };

  const getRequestStatus = (
    request: ReleaseNotesRequestKey | ReleaseNotesRequestKey[],
  ) =>
    useSelector((state: RootState) => {
      const requests = Array.isArray(request) ? request : [request];
      return combineStatuses(
        requests.map((key) => state.systemConfig.requests[key].status),
      );
    });

  const getRequestError = (
    request: ReleaseNotesRequestKey | ReleaseNotesRequestKey[],
  ) =>
    useSelector((state: RootState) => {
      const requests = Array.isArray(request) ? request : [request];

      return combineErrors(
        requests.map((key) => state.systemConfig.requests[key].error),
      );
    });

  return {
    releaseNotes,
    loadReleaseNotes,
    getRequestStatus,
    getRequestError,
  };
}
